// This storage is used to save signer's signatures
import { StateCreator } from 'zustand';
import { Signature, SignatureResponse } from '../../data/rsTypes';
import { storeResetFns } from '.';

type State = {
	signatures: any[];
	lastSavedSignature: SignatureResponse | null;
	signatureStore: Map<string, Signature>;
};

type Actions = {
	setSignatures: (signatures: any[]) => void;
	setLastSavedSignature: (signature: SignatureResponse | null) => void;
	setSignatureStore: (signatureId: string, signature: Signature) => void;
};

export type SignaturesStore = State & Actions;

const initialState: State = {
	signatures: undefined,
	lastSavedSignature: null,
	signatureStore: new Map<string, Signature>(),
};

export const createSignaturesSlice: StateCreator<SignaturesStore> = set => {
	storeResetFns.add(() => {
		set(initialState);
	});
	return {
		...initialState,
		setSignatures(signatures) {
			set(() => ({ signatures }));
		},
		setLastSavedSignature(signature) {
			set(() => ({ lastSavedSignature: signature }));
		},
		setSignatureStore(signatureId, signature) {
			set(state => {
				const newMap = new Map(state.signatureStore);
				newMap.set(signatureId, signature);
				return { signatureStore: newMap };
			});
		},
	};
};
